var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-card"},[_c('div',{staticClass:"data-card__title"},[_vm._v("Cronograma de pagos")]),_c('div',{staticClass:"data-card__body"},[_c('schedule-table',{attrs:{"schedule":_vm.schedule,"currency":_vm.currency}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }